import { defineComponent, ref } from '@vue/composition-api';
import { useHover, useFocusWithin } from '@superbet-group/web.lib.vue-utilities';

var script = defineComponent({
    name: 'SdsBaseCarouselItem',
    props: {
        isSnap: {
            type: Boolean,
            required: true,
        },
        isInert: {
            type: Boolean,
            required: true,
        },
    },
    emits: [
        'click',
        'hover',
        'focusWithin',
    ],
    setup: function (_, _a) {
        var emit = _a.emit;
        var baseCarouselItemRef = ref(null);
        useHover(baseCarouselItemRef, function (state) {
            if (baseCarouselItemRef.value) {
                emit('hover', {
                    state: state,
                    element: baseCarouselItemRef.value,
                });
            }
        });
        useFocusWithin(baseCarouselItemRef, function (state) {
            if (baseCarouselItemRef.value) {
                emit('focusWithin', {
                    state: state,
                    element: baseCarouselItemRef.value,
                });
            }
        });
        function emitClickEvent() {
            if (baseCarouselItemRef.value) {
                emit('click', {
                    element: baseCarouselItemRef.value,
                });
            }
        }
        return {
            baseCarouselItemRef: baseCarouselItemRef,
            emitClickEvent: emitClickEvent,
        };
    },
});

export default script;
